import { PharmacyOrderStatus } from "@/Common/Models/UI/Enums";
import { IPharmacyOrdersFilterSettings } from "../Api/Dto/IPharmacyOrdersFilterSettings";
import { PharmacyOrderPrescriptionType } from "../Common/PharmacyOrderPrescriptionType";

class PharmacyOrdersFilterSettingsModel {
    public preferredDateFrom: Date = null;
    public preferredDateTo: Date = null;
    public receivedDateFrom: Date = null;
    public receivedDateTo: Date = null;

    public includeArchived: boolean = false;
    public includeFiledAndContactedOrders: boolean = false;

    public selectedOrderStatus: PharmacyOrderStatus[] = [];
    public selectedPrescriptionType: PharmacyOrderPrescriptionType[] = [];

    public queryPageSize: number = 50;

    constructor(fields?: Partial<PharmacyOrdersFilterSettingsModel>) {
        Object.assign(this, fields);
    }

    public static toResponseModel(setting: PharmacyOrdersFilterSettingsModel | null): IPharmacyOrdersFilterSettings | null {
        const model = setting ?? new PharmacyOrdersFilterSettingsModel();

        return {
            PreferredDateFrom: model.preferredDateFrom,
            PreferredDateTo: model.preferredDateTo,
            ReceivedDateFrom: model.receivedDateFrom,
            ReceivedDateTo: model.receivedDateTo,
            IncludeArchived: model.includeArchived,
            IncludeFiledAndContactedOrders: model.includeFiledAndContactedOrders,
            SelectedOrderStatus: model.selectedOrderStatus,
            SelectedPrescriptionType: model.selectedPrescriptionType,
            QueryPageSize: model.queryPageSize
        };
    }

    public static fromResponseModel(orderSettingResponse: IPharmacyOrdersFilterSettings): PharmacyOrdersFilterSettingsModel {
        const settingsModel = new PharmacyOrdersFilterSettingsModel();

        if (!orderSettingResponse) {
            return settingsModel;
        }

        settingsModel.preferredDateFrom = orderSettingResponse.PreferredDateFrom;
        settingsModel.preferredDateTo = orderSettingResponse.PreferredDateTo;
        settingsModel.receivedDateFrom = orderSettingResponse.ReceivedDateFrom;
        settingsModel.receivedDateTo = orderSettingResponse.ReceivedDateTo;
        settingsModel.includeArchived = orderSettingResponse.IncludeArchived;
        settingsModel.includeFiledAndContactedOrders = orderSettingResponse.IncludeFiledAndContactedOrders ?? false;
        settingsModel.selectedOrderStatus = orderSettingResponse.SelectedOrderStatus;
        settingsModel.selectedPrescriptionType = orderSettingResponse.SelectedPrescriptionType;
        settingsModel.queryPageSize = orderSettingResponse.QueryPageSize;

        return settingsModel;
    }
}

export { PharmacyOrdersFilterSettingsModel };
